import { render, staticRenderFns } from "./VerIconos.vue?vue&type=template&id=1cc53a2e"
import script from "./VerIconos.vue?vue&type=script&lang=js"
export * from "./VerIconos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports